import {
  type LaborCostEmployeeOut,
  mapToLaborCostEmployee,
} from "@/pages/human-resources/time-management/endpoints/analysis/inout/LaborCostEmployeeOut.ts";
import type { LaborCostSection } from "@/pages/human-resources/time-management/business/analysis/LaborCostSection.ts";

export type LaborCostSectionOut = Omit<LaborCostSection, "employees"> & {
  employees: LaborCostEmployeeOut[];
};

export function mapToLaborCostSection(
  dto: LaborCostSectionOut,
): LaborCostSection {
  return {
    ...dto,
    employees: dto.employees.map(mapToLaborCostEmployee),
  };
}
